import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { LanguageState, Language } from '../types';

const useLanguageStore = create<LanguageState>()(
  persist(
    (set, get) => ({
      language: 'zh',

      setLanguage: (newLanguage: Language) => {
        set({ language: newLanguage });
        document.documentElement.setAttribute('data-language', newLanguage);
      },

      toggleLanguage: () => {
        const { language, setLanguage } = get();
        const newLanguage: Language = language === 'en' ? 'zh' : 'en';
        setLanguage(newLanguage);
      },

      initLanguage: () => {
        const { language } = get();
        document.documentElement.setAttribute('data-language', language);
      }
    }),
    {
      name: 'language-storage',
      partialize: (state) => ({
        language: state.language
      })
    }
  )
);

export default useLanguageStore;
